import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = "(max-width: 900px)";

export const isMobileViewport = (): boolean =>
  typeof window !== "undefined" && window.matchMedia(MOBILE_BREAKPOINT).matches;

export const useIsMobileViewport = (): boolean => {
  const [isMobile, setIsMobile] = useState(isMobileViewport);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    const onChange = () => {
      setIsMobile(mediaQuery.matches);
    };

    onChange();
    mediaQuery.addEventListener("change", onChange);
    return () => {
      mediaQuery.removeEventListener("change", onChange);
    };
  }, []);

  return isMobile;
};
